/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import cx from 'classnames';
import { memo } from 'react';
import { useDispatch } from 'react-redux';

import { requestSearchValue } from '../../redux/actions/main-page';
import { HEADER_LINKS } from '../../utils/constants/main-header-links';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import Link from '../Link';
import HeaderLogo from '../SVGIcons/HeaderLogo';
import classes from './main-page-footer.module.scss';

interface IMainPageFooter {
  isLoadingContent?: boolean;
}

function MainPageFooter({ isLoadingContent }: IMainPageFooter) {
  const isMobile = useMediaQuery(mediaQueries.mobile);

  const dispatch = useDispatch();

  const resetSearch = () => {
    dispatch(requestSearchValue({ searchValue: '' }));
    window.scrollTo(0, 0);
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className={cx(classes.footer, {
      [classes['footer-hidden']]: isLoadingContent,
    })}
    >
      <div className={classes.footerWrapper}>
        <div className={classes.content}>
          <div className={classes.logo}>
            <HeaderLogo fill="#fff" />
            <div>
              {!isMobile && (
                <p className={classes.greyText}>
                  {`2013 — ${currentYear} \nООО «Инстамарт Сервис»`}
                </p>
              )}
            </div>
          </div>
          <div className={classes.links}>
            {HEADER_LINKS.map((link) => (
              <Link
                isFooterLink
                isNavLink={link.isNavLink}
                typeColor="white"
                key={link.id}
                title={link.title}
                route={link.to}
                onClick={resetSearch}
              />
            ))}
          </div>
          <div className={classes.disclaymer}>
            {isMobile && (
              <p className={classes.greyText}>
                {`2013 — ${currentYear} \nООО «Инстамарт Сервис»`}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(MainPageFooter);
